module.exports = __webpack_public_path__ + "media/images/plus-fa090ac80607f66b50f2da88d420b3de.png";